<div class="subBlockContainer">
  <div class="subBlockContent" id="manageAMPSubscription">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <loading-screen *ngIf="loadContent" backDropWidth="1200" [isScrolled]="true" [showBlurTable]="false"
      (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
    <div class="child-body">
      <div class="inner-subBlock-wrapper">
        <div class="col-md-12">
          <form [formGroup]="ampManageSubForm">
            <!-- subscription details -->
            <ng-container>
              <div class="my-4">
                <h6>SUBSCRIPTION DETAILS</h6>
                <div class="my-4">
                  <div class="my-2" *ngIf="subscriptionTableView?.out_stk_description">
                    DESC :<span class="red-bold">
                      {{subscriptionTableView?.out_stk_description}}</span>
                  </div>
    
                  <div class="my-2" *ngIf="subscriptionTableView?.out_stock_code">
                    STOCKCODE :<span class="red-bold"> {{subscriptionTableView?.out_stock_code}}</span> <br>
                  </div>

                      
                  <div class="my-2" *ngIf="detail?.currentQuantity">
                    CURRENT QUANTITY :<span class="red-bold"> {{detail?.currentQuantity}}</span> <br>
                  </div>
    
                  <div class="my-2" *ngIf="detail?.usedQuantity">
                    SCHEDULED QUANTITY :<span class="red-bold"> {{subscriptionTableView?.out_qty | number: '1.0-0' }} </span> <br>
                  </div>
                </div>
              </div>
              <hr>
            </ng-container>

            <!-- manage renewal -->
            <ng-container>
              <h6>MANAGE SCHEDULED RENEWAL</h6>
              <!-- <div>
                <span class="red-bold">This subscription is being actively renewed. Updating auto renew, scheduling changes, and suspending is not available. All other actions will continue to work normally. Subscriptions may take up to 24 hours to complete their renewal</span>
              </div> -->
              <div class="row">
                <!-- left col -->
                <div class="col-md-6">
                  <div class="my-4">
                    <!-- <span>
                      Quantity increase and Upgrade will be effective instantly
                    </span> -->
                  </div>
    
                  <!-- <div class="my-4">

                    <div class="my-3">
                      <span class="highlight-text ">Subscription will autorenew at the end of the term </span> <span>{{getAutoRenwewalDate()}}</span>
                    </div>
                    <div class="my-3">
                      <span class="highlight-text">Any changes to Autorenewal need to be made at least 3 days prior to the renewal date</span>
                    </div>
                    <div *ngIf="is3YC()" class="my-3">
                      <span class="highlight-text">Autorenew can only be turned off in the 3rd year of the 3YC commitment</span>
                    </div>
    
                  </div> -->
    
                  <!-- QUANTITY-->
                  <div class="my-4">
    
                    <div>
                      <span> <span class="highlight-text">QUANTITY: </span> Scheduled : {{subscriptionTableView?.out_qty | number: '1.0-0' }}</span>
                    </div>
    
                    <ng-container>
                      <div class="my-2">
                        <span>SCHEDULE QTY CHANGES TO: </span>
                      </div>
        
                      <div class="my-2">
                        <div>
                          <input
                            type="number"
                            aria-label="Number"
                            formControlName="toQty"
                            (keypress)="onQtyTyping($event)"
                            integerOnly
                          >
                        </div>
                        <!-- <mat-spinner mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                          *ngIf="qtyLoading">
                        </mat-spinner> -->
                      </div>
                    </ng-container>

                  </div>

                  <div class="row">
                    <div class="mt-4" style="display: flex;justify-content: center;">
                      <button
                        class="button button-red button-large"
                        (click)="cancelSchedule()"
                        [disabled]="renewalProcessing || !currentUser?.hasPurchaseAccess"
                        >Cancel
                      </button>
                      <button
                        class="button button-red button-large"
                        (click)="activateNow()"
                        [disabled]="renewalProcessing || !currentUser?.hasPurchaseAccess"
                        >Activate Now
                      </button>
                      <button
                        class="button button-red button-large"
                        (click)="reschedule()"
                        [disabled]="renewalProcessing || !currentUser?.hasPurchaseAccess"
                        >Re-Schedule
                      </button>
                      <mat-spinner
                        *ngIf="renewalProcessing"
                        mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                        style="position: relative;top:15px" 
                      >
                      </mat-spinner>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
            </ng-container>

            <!-- <ng-container>
              <h6>CANCELLATION</h6>

              <div>
                <span class="highlight-text"> Cancel orders that are within the 7 day grace period</span>
              </div>
   
              <div class="row">
                <div class="mt-4" style="display: flex;justify-content: center;">
                  <button
                    class="button button-red button-large"
                    (click)="navToCancelPage()"
                    [disabled]="!isCanceling && !currentUser?.hasPurchaseAccess"
                    >Eligible Order List
                  </button>
                  <mat-spinner
                    *ngIf="isCanceling"
                    mode="indeterminate" class="circle cSPCustomerEntitlements-loading" diameter="20"
                    style="position: relative;top:15px" 
                  >
                  </mat-spinner>
                </div>
              </div>
  
            </ng-container> -->

          </form>
        </div>

      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
